import React, { useEffect, useState } from 'react';
import { useBreadcrumbs, useUser } from '../hooks';
import { Link } from 'react-router-dom';
import { EventPayout, EventDateList } from '../SiteClasses';
import { Groupper, Input, Header, Button, Table, Pagination, Message, Icon } from 'react-frontier';
import DownloadPayoutModal from '../components/DownloadPayoutModal';
import { addCommas, bindClick } from '../SiteUtil';
import UserAccess from '../UserAccess';
import moment from 'moment';
import API from '../API';

var PAGE_SIZE = 20;

var PayoutsList = ()=>{
   var { setTitle } = useBreadcrumbs();
   var { hasAccess } = useUser();
   var [loadError, setLoadError] = useState<string>(null);
   var [payouts, setPayouts] = useState<EventPayout []>(null);
   var [pendingsPayouts, setPendingsPayouts] = useState<EventPayout []>(null);
   var [unliquidatedEvents, setUnliquidatedEvents] = useState<EventDateList[]>(null);
   var [loading, setLoading] = useState<boolean>(false);
   var [pendingLoading, setPendingLoading] = useState<boolean>(false);
   var [pendingPage, setPendingPage] = useState<number>(0);
   var [completedPage, setCompletedPage] = useState<number>(0);
   var [filter, setFilter] = useState<string>('');
   var [searchPayouts, setSearchPayouts] = useState<EventPayout []>(null);
   var [searchTimeout, setSearchTimeout] = useState<any>(null);
   var [searching, setSearching] = useState<boolean>(false);
   var [selectModal, setSelectModal] = useState<boolean>(false);

	useEffect(()=>{
		setTitle('Liquidaciones');
		get();
		getPendings();
		getUnliquidated();
	}, []);

	var getUnliquidated = ()=>{
		API.getUnliquidatedEvents().then(res=>{
			if(res.error) return;
			return setUnliquidatedEvents(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al obtener las liquidaciones pendientes. (GES-2)');
		})
	};

	var get = (get_page?: number)=>{
		var offset = (get_page !== undefined) ? Math.max(0, get_page * PAGE_SIZE) : Math.max(0, completedPage * PAGE_SIZE);
		
		setLoading(true);
		API.getPayoutsList(PAGE_SIZE, offset).then(res=>{
			if(res.error) return setLoadError(res.message);
			return setPayouts(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al obtener las liquidaciones. (GES-1)');
		}).finally(()=>{
			setLoading(false);
		})
	};

	var getPendings = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || pendingPage) * PAGE_SIZE) : 0;
		
		setPendingLoading(true);
		API.getPayoutsList(PAGE_SIZE, offset, true).then(res=>{
			if(res.error) return setLoadError(res.message);
			return setPendingsPayouts(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al obtener las liquidaciones. (GES-1)');
		}).finally(()=>{
			setPendingLoading(false);
		})
	};

	var onPendingPageChange = (page: number)=>{
		setPendingLoading(true)
		setPendingPage(page);
		getPendings(page);
	}

	var onCompletedPageChange = (page: number)=>{
		setLoading(true);
		setCompletedPage(page);
		get(page);
	}

	var onSearchChange = (val: string)=>{
		setFilter(val);
		setCompletedPage(0);
		if(searchTimeout) clearTimeout(searchTimeout);
		if(val.length<3){
			setSearchPayouts(null);
			get(0);
			return;
		}
		setSearchTimeout(setTimeout(()=>{
			search(val)
		}, 500));
	}

	var search = (query: string)=>{
		setSearching(true);
		setSearchPayouts(null);
		setCompletedPage(0);
		API.searchPayouts(query).then(res=>{
			if(res.error) return setLoadError(res.message);
			setSearchPayouts(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al buscar la liquidación. (SES-1)');
		}).finally(()=>{
			setSearching(false);
		})
	}
	
	var onPayoutComplete = (pids: number[])=>{
		var cp = pendingsPayouts.filter(p => pids.includes(p.payout_id));
		setPendingsPayouts(pendingsPayouts.filter(p => !pids.includes(p.payout_id)));
		setPayouts(payouts ? [...cp, ...payouts] : cp);
		setSelectModal(false);
	}
	
	if(loadError) { return <Header text='Error' subtext={loadError} />};
	if(!payouts || !pendingsPayouts) { return <Header text='Cargando datos' loading/> };

   var shown_payouts = searchPayouts || payouts;

	return <div className='ar payouts-list-screen'>
		{unliquidatedEvents && unliquidatedEvents.length > 0 && (
			<Message className="warning-message" style={{ margin: 'auto', marginTop: 20, maxWidth: 900 }} type='warning'>
				<div className="warning-title">Eventos pendientes de liquidar</div>
				<div>
					{Object.entries(
						unliquidatedEvents.reduce<Record<string, EventDateList[]>>((acc, e) => {
							var key = e.user_coordinator_name;
							if (!acc[key]) acc[key] = [];
							acc[key].push(e);
							return acc;
						}, {})
					).map(([coordinator, events]) => (
						<div key={coordinator} className="coordinator-block">
							<div className="coordinator-title">{coordinator}</div>
							<ul>
								{events.map(e => (
									<li key={e.date_id}>
										<Link to={`/events/${e.date_id}`} style={{ color: 'inherit', textDecoration: 'none' }}>
											<b>{e.event_name}</b> ({moment.unix(e.date).format('DD/MM/YYYY')})
										</Link>
									</li>
								))}
							</ul>
						</div>
					))}
				</div>
			</Message>
		)}
		<Table
			title='Pendientes'
			className="table"
			style={{ margin: 'auto', marginTop: 20, maxWidth: 900 }}
			headers={['ID', 'Evento', 'COORDINADOR', 'CANTIDAD', 'PAGOS', 'FECHA']}
			button={hasAccess(UserAccess.ACCOUNTING.PAID_PAYOUT) ? (
				<Button iconName='check-circle' text='Seleccionar' color='black' size='small' onClick={bindClick(setSelectModal, true)}/>
			) : undefined}
			footer={(pendingsPayouts && (pendingsPayouts.length >= PAGE_SIZE || pendingPage !== 0)) && (
				<Table.Cell colSpan={10} row>
					<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
						<Pagination page={pendingPage} onPageChange={onPendingPageChange} hasNext={pendingsPayouts && Array.isArray(pendingsPayouts) && pendingsPayouts.length >= PAGE_SIZE} />
					</div>
				</Table.Cell>
			)}
		>
			{pendingLoading ? (
				<Table.Cell row className='empty' colSpan={5}>
					<Header loading text='Cargando datos' />
				</Table.Cell>
			) : !pendingsPayouts || !Array.isArray(pendingsPayouts) || pendingsPayouts.length === 0 ? (
				<Table.Cell row className='empty' colSpan={5}>
					No hay liquidaciones pendientes
				</Table.Cell>
			) : (
				pendingsPayouts.map(p=>(
					<Table.Row
						selectable
						striped
						compact
						key={p.payout_id}
						as={Link}
						to={`/payouts/${p.payout_id}`}
						collapsingIndexes={[0, 2, 3, 4, 5, 6]}
						centeredIndexes={[4, 2]}
						data={[
							p.payout_id,
							p.event_name,
							p.user_coordinator_name || <Icon name='minus' />,
							'$'+ addCommas(p.total_amount),
							p.worker_count,
							moment.unix(p.date_created).format('DD/MM/YY HH:mm'),
						]}
					/>
				))
			)}
		</Table>
		<Groupper title={'Liquidaciones'} width={900} style={{ marginTop: 20 }} >
			<Input placeholder='Buscar...' value={filter} onChange={onSearchChange} className="input" />
			<Table striped
				className='first last table'
				headers={['ID', 'Evento', 'COORDINADOR', 'CANTIDAD', 'Pagos', 'FECHA']}
				footer={(shown_payouts && (shown_payouts.length >= PAGE_SIZE || completedPage !== 0)) && (
					<Table.Cell colSpan={10} row>
						<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
							<Pagination page={completedPage} onPageChange={onCompletedPageChange} hasNext={shown_payouts && shown_payouts.length >= PAGE_SIZE} />
						</div>
					</Table.Cell>
				)}
			>
				{searching || loading ? (
					<Table.Cell row className='empty' colSpan={5}>
						<Header loading text='Cargando datos' />
					</Table.Cell>
				) : !shown_payouts || !Array.isArray(shown_payouts) || shown_payouts.length === 0 ? (
					<Table.Cell row className='empty' colSpan={5}>
						No se encontraron registros
					</Table.Cell>
				) : (
					shown_payouts.map(p=>(
						<Table.Row
							selectable
							striped
							compact
							key={p.payout_id}
							as={Link}
							to={`/payouts/${p.payout_id}`}
							collapsingIndexes={[0, 2, 3, 4, 5, 6]}
							centeredIndexes={[4]}
							data={[
								p.payout_id,
								p.event_name,
								p.user_coordinator_name,
								'$'+ addCommas(p.total_amount),
								p.worker_count,
								moment.unix(p.date_created).format('DD/MM/YY HH:mm'),
							]}
						/>
					))
				)}
			</Table>
		</Groupper>
		{selectModal && (
			<DownloadPayoutModal
				open={selectModal}
				payouts={pendingsPayouts}
				onClose={() => setSelectModal(false)}
				onComplete={onPayoutComplete}
			/>
		)}
	</div>
}

export default PayoutsList;
